import CenteredLayout from '../components/layouts/CenteredLayout'

function NotFound(): JSX.Element {
  return <CenteredLayout>Not Found</CenteredLayout>
}

export default NotFound
